/** Whether a Web Client result carries an `errors` payload (some methods answer HTTP 200 with one). */
export function hasErrors(result: any): boolean {
  return !!(result && result.errors && result.errors.length);
}
